import { prefixObjectValues as pre } from '../utils';

const prefix = 'ag-grid';

const table = pre(
  {
    filterFromDate: 'filter-from-input',
    filterToDate: 'filter-to-input',
    filterCheckbox: 'filter-checkbox',
    success: 'success-check',
    warning: 'warning-check',
    failure: 'failure-check',
    actionBtn: 'action-btn',
    warningIcon: 'warning-icon',
    deleteBtn: 'delete-btn',
    editBtn: 'edit-btn',
    clearFiltersBtn: 'clear-filters-btn',
  },
  prefix
);

export default {
  ...table,
};
